import React from "react";
import { ShieldAlert } from "lucide-react";

/* Conditional, REQUIRED safety acknowledgments — one block per triggered
 * category. Never pre-checked. Separate from Terms and from SMS consent. */
export const SafetyAcknowledgments = ({ acks, accepted, setAccepted }) => {
  if (!acks.length) return null;
  return (
    <div className="space-y-4" data-testid="safety-acknowledgments">
      {acks.map((ack) => (
        <div key={ack.key} className="glass p-5 sm:p-6 text-sm text-[#F6F1E4] border-[#F4A93A]/40" data-testid={`ack-${ack.key}`}>
          <h3 className="font-serif text-lg text-[#F4A93A] flex items-center gap-2" data-testid={`ack-${ack.key}-heading`}>
            <ShieldAlert className="w-4 h-4" /> {ack.heading}
          </h3>
          <div className="mt-3 space-y-2 text-[13px] leading-relaxed text-[#E4E9EF]" data-testid={`ack-${ack.key}-text`}>
            {ack.paragraphs.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
          </div>
          <label className="mt-4 flex items-start gap-3 cursor-pointer rounded-lg border border-[#F4A93A]/40 bg-[#F4A93A]/5 p-3" data-testid={`ack-${ack.key}-wrap`}>
            <input
              type="checkbox"
              required
              checked={!!accepted[ack.key]}
              onChange={(e) => setAccepted((cur) => ({ ...cur, [ack.key]: e.target.checked }))}
              className="mt-0.5 w-5 h-5 accent-[#F4A93A]"
              data-testid={`ack-${ack.key}-checkbox`}
            />
            <span className="font-medium">{ack.checkbox}</span>
          </label>
          <p className="mt-2 text-[10px] text-[#B9C8D5]">Version {ack.version} · required to complete this reservation</p>
        </div>
      ))}
    </div>
  );
};
